
import { Vue, Component } from 'vue-property-decorator';
import { BASE_URL } from '@/common/constant';
import lazyInject from '@/di';
import UserService from '@/services/user.service';


@Component
export default class ImgUpload extends Vue {
  action = 'https://api.example.com/upload';

  @lazyInject(UserService)
  protected userService!: UserService;
  uploading = false;

  BASE_URL = BASE_URL;

  beforeFile: any = {};

  beforeUpload(file: any) {
    // console.log(file);
    this.beforeFile = file;
  }
  created() {
    // this.options.headers.AUTHORIZATION = this.userService.currentUser()?.token;
    // this.token = this.userService.currentUser()?.token;
  }
}
